import { z } from "zod";
import {
  consigneeAndDeliverySchema,
  shipperSchema,
  weightUnitSchema,
} from "../../../services/prePlanningService.types";
import { tagSchema } from "../../freight/tag.type";

const appointmentRequiredShipmentSchema = z.object({
  id: z.number(),
  proNumber: z.string(),
  daysOnHand: z.number(),
  presetRouteId: z.number(),
  presetRouteName: z.string(),
  consignee: consigneeAndDeliverySchema.nullish(),
  delivery: consigneeAndDeliverySchema.nullish(),
  destinationSicCode: z.string().nullish(),
  trailerNumber: z.string().nullish(),
  status: z.string(),
  assignment: z.string().nullish(),
  serviceDueDate: z.date(),
  appointmentDate: z.date().nullable(),
  appointmentEndDate: z.date().nullable(),
  appointmentTime: z.number().nullable(),
  shipper: shipperSchema.nullish().transform((x) => x ?? undefined),
  pallets: z.number(),
  pieces: z.number(),
  handlingUnits: z.number(),
  weight: z.number(),
  weightUnit: weightUnitSchema,
  tags: z.array(tagSchema),
  isPlanned: z.boolean(),
});

export const appointmentRequiredShipmentsSchema = z.array(
  appointmentRequiredShipmentSchema
);

export type AppointmentRequiredShipment = z.infer<
  typeof appointmentRequiredShipmentSchema
>;
